import { render } from "./MilitaryStudentView.vue?vue&type=template&id=2bcd7248&scoped=true"
import script from "./MilitaryStudentView.vue?vue&type=script&lang=js"
export * from "./MilitaryStudentView.vue?vue&type=script&lang=js"

import "./MilitaryStudentView.vue?vue&type=style&index=0&id=2bcd7248&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcd7248"]])

export default __exports__